import instance from '@/services/repository';

const resource = '/projects';

export default {
    get(projectId: string) {
        return instance.get(`${resource}/${projectId}/Visits`);
    },
    create(projectId: string, payload: IProjectVisit) {
        return instance.post(`${resource}/${projectId}/Visits`, payload);
    },
    copy(projectId: string, pageId: string) {
        return instance.post(`${resource}/${projectId}/Visits/Copy/${pageId}`);
    },
    update(projectId: string, payload: IProjectVisit) {
        return instance.put(`${resource}/${projectId}/Visits`, payload);
    },
    delete(projectId: string, pageId: string) {
        return instance.delete(`${resource}/${projectId}/Visits/${pageId}`);
    },
};
